import { Component, Input, TemplateRef } from '@angular/core';



export class PlannerBoardColumnComponent {
   columnBody: TemplateRef<any>;
   itemCount: number;
   columnName: string;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'f8-planner-column',
  templateUrl: './planner-board-column.component.html',
  styleUrls: ['./planner-board-column.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'columnBody': [{ type: Input },],
'itemCount': [{ type: Input },],
'columnName': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
